// extracted by mini-css-extract-plugin
export default {"container":"HistoryBlock_container__cAyZe","title":"HistoryBlock_title__x9ASg"};